<template>
  <div>
    <label>Filter By Client</label>
    <el-select
      class="select-primary"
      size="large"
      placeholder="Select Client Campaign Type"
      filterable
      default-first-option
      v-model="selectedGroupCompany"
      v-on:change="onGroupChange($event)"
    >
      <el-option
        v-for="(item, index) in this.$global.selectsGroupCompany.companyGroupList"
        class="select-primary"
        :value="item.id"
        :label="item.group_name"
        :key="index">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  name: 'select-client-dropdown-dashboard',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      selectedGroupCompany: ''
    }
  },
  methods: {
    onGroupChange(event) {
      localStorage.setItem('companyGroupSelected', event);
      this.$router.go();
    },
  },
  mounted() {
    this.selectedGroupCompany = '';
    if (localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '') {
      this.selectedGroupCompany = Number(localStorage.getItem('companyGroupSelected'));
    }
  }
}
</script>
